import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { DecisionPoint } from "@/helpers/waves/time.types";
import { HorizontalTimelineDot } from "./HorizontalTimelineDot";
import { Time } from "@/helpers/time";
interface HorizontalTimelineItemProps {
  readonly decision: DecisionPoint;
  readonly isNext: boolean;
  readonly flexGrow?: boolean | undefined;
}

/**
 * Renders a single item in the horizontal timeline
 */
export const HorizontalTimelineItem: React.FC<HorizontalTimelineItemProps> = t0 => {
  const $ = _c(25);
  const {
    decision,
    isNext,
    flexGrow: t1
  } = t0;
  const flexGrow = t1 === undefined ? false : t1;
  const isPast = decision.timestamp < Time.currentMillis();
  const t2 = `tw-relative tw-flex tw-flex-col tw-items-center tw-z-10 ${flexGrow ? "tw-flex-1" : "tw-flex-shrink-0 tw-w-[80px]"}`;
  let t3;
  if ($[0] !== isNext || $[1] !== isPast) {
    t3 = <div className="tw-mb-3 tw-z-10"><HorizontalTimelineDot isNext={isNext} isPast={isPast} /></div>;
    $[0] = isNext;
    $[1] = isPast;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== isNext) {
    t4 = isNext && <span className="tw-flex tw-justify-center tw-mb-1"><span className="tw-inline-flex tw-items-center tw-rounded-full tw-bg-primary-500/20 tw-px-1.5 tw-py-0.5 tw-text-[10px] tw-font-medium tw-text-primary-400">Next</span></span>;
    $[3] = isNext;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== isPast) {
    t5 = isPast && <span className="tw-flex tw-justify-center tw-mb-1"><span className="tw-inline-flex tw-items-center tw-rounded-full tw-px-1.5 tw-py-0.5 tw-text-[10px] tw-font-medium tw-text-iron-500">Completed</span></span>;
    $[5] = isPast;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = `tw-text-xs ${isNext ? "tw-text-iron-100" : "tw-text-iron-400"} tw-font-medium`;
  let t7;
  if ($[7] !== decision.timestamp) {
    t7 = new Date(decision.timestamp).toLocaleDateString(undefined, {
      month: "short",
      day: "numeric"
    });
    $[7] = decision.timestamp;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t6 || $[10] !== t7) {
    t8 = <div className={t6}>{t7}</div>;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== decision.timestamp) {
    t9 = new Date(decision.timestamp).toLocaleTimeString(undefined, {
      hour: "2-digit",
      minute: "2-digit"
    });
    $[12] = decision.timestamp;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t9) {
    t10 = <div className="tw-text-xs tw-text-iron-500 tw-mt-0.5 tw-font-mono">{t9}</div>;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t10 || $[17] !== t4 || $[18] !== t5 || $[19] !== t8) {
    t11 = <div className="tw-mt-2 tw-z-10 tw-text-center">{t4}{t5}{t8}{t10}</div>;
    $[16] = t10;
    $[17] = t4;
    $[18] = t5;
    $[19] = t8;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t11 || $[22] !== t2 || $[23] !== t3) {
    t12 = <div className={t2}>{t3}{t11}</div>;
    $[21] = t11;
    $[22] = t2;
    $[23] = t3;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  return t12;
};